import Core, { CoreConfig, damp } from "smooothy"
import gsap from "gsap"

class ControlsSlider extends Core {
  private dots: Array<Element>;
  private arrows: Array<HTMLButtonElement>;

  constructor(container: HTMLElement, config?: Partial<CoreConfig>) {
    const slider: HTMLElement = container.querySelector("[data-slider]");
    super(slider, config)

    const interfaceElemenet: HTMLElement = container.querySelector("[data-interface]");
    this.createInterface(interfaceElemenet);

    this.onSlideChange(0, 0);
  }

  createInterface(int: HTMLElement) {
    this.dots = [...int.querySelector("[data-dots]").children]
    this.arrows = [...int.querySelector("[data-arrows]").children]

    this.arrows.forEach((arrow, index) => {
      arrow.addEventListener('click', () => {
        if (index === 0) {
          this.goToPrev()
        } else {
          this.goToNext()
        }
      }, {passive: true});
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToIndex(index);
      }, {passive: true})
    });
  }

  onSlideChange = (current: number, previous: number) => {
    this.items[previous].children[0].children[0].classList.remove("active")
    this.items[current].children[0].children[0].classList.add("active")

    this.dots[previous].classList.remove("active-dot")
    this.dots[current].classList.add("active-dot")

    this.arrows[0].disabled = false;
    this.arrows[1].disabled = false;

    if (current == 0) {
      this.arrows[0].disabled = true;
    }

    if (current  == this.items.length - 1) {
      this.arrows[1].disabled = true;
    }
  }
}




const sliderElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-slider');
sliderElements?.forEach(sliderElement => {

  const slider = new ControlsSlider(sliderElement, {
    infinite: false,
    snap: true,
    snapStrength: 1,
    bounceLimit: 0.5,
    lerpFactor: 0.1,
    speedDecay: 1,
  });

  // Update the slider (typically in an animation loop)
  function animate() {
    slider.update()
    requestAnimationFrame(animate)
  }
  animate()
});
